import { ArrowRight, Sparkles } from 'lucide-react';
import { Card, CardContent } from '@g17eco/ui-modern/components/ui/card';
import { Button } from '@g17eco/ui-modern/components/ui/button';

interface WelcomeCardProps {
  onStart: () => void;
  isStarting: boolean;
}

export const WelcomeCard = ({ onStart, isStarting }: WelcomeCardProps) => {
  return (
    <Card className='tw:max-w-2xl tw:mx-auto tw:mt-8'>
      <CardContent className='tw:flex tw:flex-col tw:items-center tw:text-center tw:py-12 tw:px-8'>
        <div className='tw:mb-4 tw:flex tw:size-16 tw:items-center tw:justify-center tw:rounded-full tw:bg-emerald-100 tw:text-emerald-700'>
          <Sparkles className='tw:size-8' />
        </div>

        <h2 className='tw:text-2xl tw:font-semibold tw:mb-2'>
          Welcome to Emissions Tracker
        </h2>

        <p className='tw:text-sm tw:text-muted-foreground tw:max-w-md tw:mb-6'>
          Track carbon emissions across Scope 1, 2, and 3 activities, set reduction targets,
          and surface insights for your sustainability reporting. Let us walk you through
          the first few steps to set up your organisation.
        </p>

        <Button variant='emerald' onClick={onStart} disabled={isStarting}>
          Start now
          <ArrowRight className='tw:size-4' />
        </Button>
      </CardContent>
    </Card>
  );
};
